/* global Chart */

(function($) {
    'use strict';
    var Calculator = function(el) {
        this.$el = $(el);
        // this.$close = this.$el.find('.message-close');
        this.id = this.$el.prop('id');
        this.max = parseFloat(this.$el.attr('max'));
        this.min = parseFloat(this.$el.attr('min'));
        this.val = parseFloat(this.$el.attr('value'));
        this.step = parseFloat(this.$el.attr('step'));
        this.corr = parseFloat(this.$el.attr('corr'));
        window.pies = [];
        this.pieData = [
            {
                value: 0,
                color: '#84bb36'
            },
            {
                value: 100,
                color: '#f8f5f1'
            }
        ];
        this.pieOptions = {
            animation: false,
            showTooltips: false
        };
        if ($('#chart-area-' + this.id).length) {
            window.ctx = document
                .getElementById('chart-area-' + this.id)
                .getContext('2d');
            window.pies[this.id] = new Chart(window.ctx).Pie(
                this.pieData,
                this.pieOptions
            );
        }
        this.init();
    };
    Calculator.prototype = {
        init: function() {
            var that = this;
            that.bindEvents();
            that.doCalcs('org');
            that.doCalcs('new');
            $('#' + that.id + ' .noUi-base .noUi-background .noUi-handle').text(
                $('#new-val-' + that.id).text()
            );
        },
        bindEvents: function() {
            var that = this;
            var slider = $('#' + this.id).noUiSlider({
                start: that.val,
                step: that.step,
                connect: 'lower',
                orientation: 'horizontal',
                range: {
                    min: that.min,
                    max: that.max
                }
            });
            $('#' + this.id).on('slide', function() {
                $('#new-val-' + that.id).text(slider.val());
                $('#' + that.id + ' .noUi-base .noUi-background .noUi-handle').text(
                    Math.round(slider.val() * 10) / 10
                );
                that.doCalcs('new');
                that.copyPercentage();
            });
            $('.tabledropper').click(function() {
                that.dropTable($(this));
            });
            $('.close-table').click(function() {
                that.closeTable($(this).parent().parent().parent());
            });
        },
        dropTable: function(link) {
            if ($('.dropped').get(0)) {
                if ($(link.context.rel).hasClass('dropped')) {
                    $('.dropped').slideUp('fast', function() {
                        $(this).removeClass('dropped');
                    });

                    return true;
                }
                $('.dropped').slideUp('fast', function() {
                    $(this).removeClass('dropped');
                    $(link.context.rel).slideDown('fast', function() {
                        $(this).addClass('dropped');
                    });
                });
            } else {
                $(link.context.rel).slideDown('fast', function() {
                    $(this).addClass('dropped');
                });
            }
        },
        closeTable: function(table) {
            table.slideUp('fast', function() {
                table.removeClass('dropped');
            });
        },
        doCalcs: function(arg) {
            var divId;
            if (arg === 'new') {
                divId = 2;
            } else {
                divId = 1;
            }
            $('#bw-1-' + divId).text(this.calcBRWBInterventionsPerDay(arg));
            $('.better tbody tr:first td.' + divId).text(
                this.calcBRWBInterventionsPerDay(arg)
            );
            $('#bw-2-' + divId).text(this.calcBRWBPadChange(arg));
            $('.better tbody tr:nth-child(2) td.' + divId).text(
                this.calcBRWBPadChange(arg)
            );
            $('#bw-3-' + divId).text(this.calcBRWBLeakageLaundry(arg));
            $('.better tbody tr:nth-child(3) td.' + divId).text(
                this.calcBRWBLeakageLaundry(arg)
            );
            $('#bw-4-' + divId).text(this.calcBRWBSkincare(arg));
            $('.better tbody tr:nth-child(4) td.' + divId).text(
                this.calcBRWBSkincare(arg)
            );
            this.calcImprovements('better', 4);
            $('#bwa-1-' + divId).text(this.calcBWAIncontinenceCarePerDay(arg));
            $('.bwa tbody tr:first td.' + divId).text(
                this.calcBWAIncontinenceCarePerDay(arg)
            );
            $('#bwa-2-' + divId).text(this.calcBWAPadChangeAlt(arg));
            $('.bwa tbody tr:nth-child(2) td.' + divId).text(
                this.calcBWAPadChangeAlt(arg)
            );
            $('#bwa-3-' + divId).text(this.calcBWALeakageLaundry(arg));
            $('.bwa tbody tr:nth-child(3) td.' + divId).text(
                this.calcBWALeakageLaundry(arg)
            );
            $('#bwa-4-' + divId).text(this.calcBWASkincare(arg));
            $('.bwa tbody tr:nth-child(4) td.' + divId).text(this.calcBWASkincare(arg));
            this.calcImprovements('bwa', 4);
            $('#bb-1-' + divId).text(this.calcBBPadCost(arg));
            $('.bb tbody tr:first td.' + divId).text(this.calcBBPadCost(arg));
            $('#bb-2-' + divId).text(this.calcBBLeakageLaundry(arg));
            $('.bb tbody tr:nth-child(2) td.' + divId).text(
                this.calcBBLeakageLaundry(arg)
            );
            $('#bb-3-' + divId).text(this.calcBBSkincare(arg));
            $('.bb tbody tr:nth-child(3) td.' + divId).text(this.calcBBSkincare(arg));
            $('#bb-4-' + divId).text(this.calcBBWaste(arg));
            $('.bb tbody tr:nth-child(4) td.' + divId).text(this.calcBBWaste(arg));
            this.calcImprovements('bb', 4);
            $('#be-1-' + divId).text(
                this.calcBELaundry(arg) + this.calcBEMaterialsCounsumption(arg)
            );
            $('.be tbody tr:first td.' + divId).text(
                this.calcBELaundry(arg) + this.calcBEMaterialsCounsumption(arg)
            );
            $('#be-2-' + divId).text(
                this.calcBEEnergyFootprint(arg) + this.calcBEMaterialsCounsumption(arg)
            );
            $('.be tbody tr:nth-child(2) td.' + divId).text(
                this.calcBEEnergyFootprint(arg) + this.calcBEMaterialsCounsumption(arg)
            );
            $('#be-3-' + divId).text(this.calcBELaundry(arg));
            $('.be tbody tr:nth-child(3) td.' + divId).text(this.calcBELaundry(arg));
            $('#be-4-' + divId).text(this.calcBEEnergyFootprint(arg));
            $('.be tbody tr:nth-child(4) td.' + divId).text(
                this.calcBEEnergyFootprint(arg)
            );
            $('#be-5-' + divId).text(this.calcBEMaterialsCounsumption(arg));
            $('.be tbody tr:nth-child(5) td.' + divId).text(
                this.calcBEMaterialsCounsumption(arg)
            );
            this.calcImprovements('be', 5);
        },
        copyPercentage: function() {
            $('.improvement-1').text($('.better tbody tr:nth-child(1) td.3').text());
            $('.improvement-2').text($('.bwa tbody tr:nth-child(1) td.3').text());
            $('.improvement-3').text($('.bb tbody tr:nth-child(1) td.3').text());
            $('.improvement-4').text($('.be tbody tr:nth-child(1) td.3').text());
        },
        calcImprovements: function(prefix, rows) {
            var target = '.' + prefix;
            for (var row = 1; row <= rows; row++) {
                // var before = $('#'+ prefix +'-'+ i +'-1').text();
                // var after = $('#'+ prefix +'-'+ i +'-2').text();
                var before = $(target + ' tbody tr:nth-child(' + row + ') td.1').text();
                var after = $(target + ' tbody tr:nth-child(' + row + ') td.2').text();
                var operator = null;
                var result = null;
                if (before === 0) {
                    if (after / before < 1) {
                        operator = '-';
                    }
                    result = operator + 'Infinity%';
                    $(target + ' tbody tr:nth-child(' + row + ') td.3').html(result);
                } else {
                    result = Math.round(-(after / before * 100) + 100);
                    $(target + ' tbody tr:nth-child(' + row + ') td.3').html(
                        result + '%'
                    );
                }
            }
        },
        /**
		 * Better Resident Well-Being functions
         * @returns {number}
		 */
        calcBRWBInterventionsPerDay: function() {
            var calcOne = this.calcBRWBPadChange('new');
            var calcTwo = this.calcBRWBLeakageLaundry('new');
            var calcThree = this.calcBRWBSkincare('new');

            return Math.round(calcOne + calcTwo + calcThree);
        },
        calcBRWBPadChange: function(arg) {
            var result = $('#' + arg + '-val-1').text() * 50 * 0.8;

            return Math.round(result);
        },
        calcBRWBLeakageLaundry: function(arg) {
            var result =
                $('#' + arg + '-val-1').text() *
                ($('#' + arg + '-val-5').text() / 100) *
                50 *
                0.8;

            return Math.round(result);
        },
        calcBRWBSkincare: function(arg) {
            var result = $('#' + arg + '-val-3').text() / 100 * 50 * 0.8;

            return Math.round(result);
        },
        /**
		 * Better Working Atmosphere functions
         * @param {string} field
         * @returns {number}
		 */
        calcBWAIncontinenceCarePerDay: function(field) {
            var calcOne = this.calcBWAPadChangeAlt(field);
            var calcTwo = this.calcBWALeakageLaundry(field);
            var calcThree = this.calcBWASkincare(field);

            return Math.round(calcOne + calcTwo + calcThree);
        },
        calcBWAPadChangeAlt: function(field) {
            var result =
                50 *
                0.8 *
                $('#' + field + '-val-1').text() *
                ($('#' + field + '-val-4').text() / 60) *
                $('#' + field + '-val-2').text();

            return Math.round(result);
        },
        calcBWALeakageLaundry: function(field) {
            var result =
                50 *
                0.8 *
                $('#' + field + '-val-1').text() *
                ($('#' + field + '-val-5').text() / 100) *
                (14 / 60);

            return Math.round(result);
        },
        calcBWASkincare: function(field) {
            var result = 50 * 0.8 * ($('#' + field + '-val-3').text() / 100) * (10 / 60);

            return Math.round(result);
        },
        /**
		 * Better for the budget functions
		 * @param {string} field
         * @returns {number}
		 */
        calcBBPadCost: function(field) {
            var calcOne = this.calcBBLeakageLaundry(field);
            var calcTwo = this.calcBBSkincare(field);
            var calcThree = this.calcBBWaste(field);

            return Math.round(calcOne + calcTwo + calcThree);
        },
        calcBBLeakageLaundry: function(field) {
            var result =
                $('#' + field + '-val-1').text() *
                $('#' + field + '-val-5').text() /
                100 *
                50 *
                0.8 *
                2.7;

            return Math.round(result);
        },
        calcBBSkincare: function(field) {
            var result = $('#' + field + '-val-3').text() / 100 * 50 * 0.8 * 0.45;

            return Math.round(result);
        },
        calcBBWaste: function(field) {
            var result = $('#' + field + '-val-1').text() * 0.11 * 0.5 * 50 * 0.8;

            return Math.round(result);
        },
        /**
		 * Better for the Environment functions
		 * @param {string} field
         * @returns {number}
		 */
        calcBELaundry: function(field) {
            // räätt
            var result =
                50 *
                0.8 *
                $('#' + field + '-val-1').text() *
                ($('#' + field + '-val-5').text() / 100) *
                1 *
                365;

            return Math.round(result);
        },
        calcBEEnergyFootprint: function() {
            var result = this.calcBELaundry('new') * (1.2 + 3.5) * 0.527 / 4;

            return Math.round(result);
        },
        calcBEMaterialsCounsumption: function(field) {
            var result = 50 * 0.8 * $('#' + field + '-val-1').text() * 0.11 * 365;

            return Math.round(result);
        }
    };
    $.fn.calculator = function(options) {
        var args = Array.prototype.slice.call(arguments, 1),
            $this,
            data;

        return this.each(function() {
            $this = $(this);
            data = $this.data('calculator');
            if (!data) {
                $this.data('calculator', (data = new Calculator(this, options)));
            }
            if (typeof options === 'string') {
                data[options](args);
            }
        });
    };
    $.fn.calculator.Constructor = Calculator;
})(jQuery);
